// Vendors
import React, { createContext, useContext, useState } from 'react';
// Types
import { LayoutType } from 'components/layout/types/layout.type';
import {
  LayoutApiDataContextType,
  LayoutButtonContextType,
  LayoutContextType,
} from './types/layout.context.type';

const LayoutContext = createContext<LayoutContextType>({} as LayoutContextType);

const LayoutContextProvider = ({
  children,
}: {
  children: React.ReactElement;
}): React.ReactElement => {
  const [flowApiData, setFlowApiData] = useState<LayoutApiDataContextType>({});
  const [mainButtonConfiguration, setMainButtonConfiguration] = useState<LayoutButtonContextType>(
    {}
  );
  const [buttonGhostConfiguration, setButtonGhostConfiguration] = useState<LayoutButtonContextType>(
    {}
  );
  const [compactView, setCompactView] = useState<boolean>(false);

  return (
    <LayoutContext.Provider
      value={{
        buttonGhostConfiguration,
        compactView,
        flowApiData,
        mainButtonConfiguration,
        setButtonGhostConfiguration,
        setCompactView,
        setFlowApiData,
        setMainButtonConfiguration,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

const useLayoutContextConsumerHook = (): LayoutContextType => useContext(LayoutContext);

/* eslint-disable */
const LayoutContextConsumerHOC =
  (Component: React.FunctionComponent<LayoutType>): React.FunctionComponent<LayoutType> =>
  (props: any): React.ReactElement<React.Provider<LayoutContextType>> =>
    (
      <LayoutContextProvider>
        <Component {...props} />
      </LayoutContextProvider>
    );

export { LayoutContextConsumerHOC, LayoutContextProvider, useLayoutContextConsumerHook };
